<div class="filter-group">
  <ng-content></ng-content>
</div>
